import React, { createContext, useContext, useEffect } from 'react';
import { useSubscriptionStore } from '../stores/subscriptionStore';
import { useAuth } from './AuthContext';

// Exported for the demo harness, which mounts signed-in pages with a plan of its own
export const SubscriptionContext = createContext(null);

export const SubscriptionProvider = ({ children }) => {
  const store = useSubscriptionStore();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      store.fetchSubscription();
    } else {
      store.resetSubscription();
    }
  }, [isAuthenticated]);

  const value = {
    subscription: store.subscription,
    loading: store.loading,
    error: store.error,
    isProPlan: store.isProPlan,
    openCustomerPortal: store.openCustomerPortal,
    setSubscription: store.setSubscription,
  };

  return (
    <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);